module.exports = __webpack_public_path__ + "img/logo_aby.e1959188.png";